import React from "react";
import "./BridalMakeupOn.css";

function BridalMakeupOn(props) {
  const { polygon33, bridalMakeup } = props;

  return (
    <div className="bridal-makeup-on">
      <div className="overlap-group-10">
        <div className="rectangle-117"></div>
        <img className="polygon-33" src={polygon33} />
        <div className="bridal-makeup-4 poppins-medium-white-10px">{bridalMakeup}</div>
      </div>
    </div>
  );
}

export default BridalMakeupOn;
